import {
  getCurrencyMinorUnitExponent,
  getCurrencySymbol,
  type CurrencyCode,
} from '@dinewise/utils';

export const resolveCurrencyFieldOptions = (
  currencyCode: CurrencyCode = 'USD',
  decimals?: number,
) => ({
  decimals: decimals ?? getCurrencyMinorUnitExponent(currencyCode),
  currencySymbol: getCurrencySymbol(currencyCode),
});
